/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProductCategoryDto } from '../../models/create-product-category-dto';
import { ProductCategoryDto } from '../../models/product-category-dto';

export interface ProductCategoryControllerCreate$Params {
      body: CreateProductCategoryDto
}

export function productCategoryControllerCreate(http: HttpClient, rootUrl: string, params: ProductCategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductCategoryDto>;
    })
  );
}

productCategoryControllerCreate.PATH = '/api/product-category';
